import { render, staticRenderFns } from "./organizationSettings.vue?vue&type=template&id=370fa45e&scoped=true&lang=pug"
import script from "./organizationSettings.vue?vue&type=script&lang=js"
export * from "./organizationSettings.vue?vue&type=script&lang=js"
import style0 from "./organizationSettings.vue?vue&type=style&index=0&id=370fa45e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370fa45e",
  null
  
)

export default component.exports